import { TransactionStatus } from '@seapoint/server/enums';
import { TransactionView } from '../../../types/entity-types';

type GetTotalDebitTransferAmountArgs = {
  transactions?: TransactionView[];
};

export const getTotalDebitTransferAmount = ({ transactions }: GetTotalDebitTransferAmountArgs) => {
  if (!transactions) {
    return 0;
  }

  return transactions.reduce(
    (acc, transaction) =>
      transaction.status === TransactionStatus.BOOKED && !transaction.isCredit ? acc + transaction.amount : acc,
    0,
  );
};
